import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'caption'
})
export class CaptionPipe implements PipeTransform {

  transform(value: string): string {

    try {
      value = JSON.parse(value)[`${localStorage.getItem('language')}`];
    } catch {
      return value;
    }

    return value;

  }

}
